import { LoaderProps, Loader as MantineLoader, Stack } from "@mantine/core"

type Props = {
  color?: string
  fullPage?: boolean
} & LoaderProps

export const Loader = ({ fullPage, color = "primary", ...props }: Props) => {
  if (fullPage) {
    return (
      <Stack align="center" w="100%" h="100%" mt="5%">
        <MantineLoader color={color} {...props} />
      </Stack>
    )
  }
  return <MantineLoader color={color} {...props} />
}
